/**
 * Identidade da plataforma (white-label). Para renomear o produto, altere aqui
 * e as variáveis APP_NAME / VITE_APP_NAME no .env.
 */
export const BRAND = {
  name: 'Dezza',
  tagline: 'Sua loja inteira num app só.',
  // Contato do suporte da plataforma. Vazio = os blocos de contato ficam ocultos (site, Ajuda).
  // Preencha com um e-mail e um WhatsApp que o dono do Dezza controla antes de divulgar.
  supportEmail: '' as string,
  supportWhatsapp: '' as string,
  // Cores da marca v2 (docs/BRAND.md). Usadas fora do CSS, ex.: nos e-mails.
  colors: {
    primary: '#6B4EFF',
    primaryHover: '#5B3DF2',
    primaryBright: '#C8F169',
    dark: '#0E0E14',
    background: '#F6F6F8',
    danger: '#D93036',
    gold: '#FFB81C',
  },
} as const;

export type Brand = typeof BRAND;
